import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../api";
import Loader from "../components/Loader";

const CurrencyContext = createContext();

export const CurrencyProvider = ({ children }) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [usd, setUsd] = useState(null);
    const [cny, setCny] = useState(null);
    const [courseDate, setCourseDate] = useState(null);

    useEffect(() => {
        const fetchCurrencies = async () => {
            try {
                const response = await api.get("/api/courses");
                const data = response.data;

                const usdRate = data.find(c => c.shortName === "USD");
                const cnyRate = data.find(c => c.shortName === "CNY");
                setCourseDate(data.find(c => c.shortName === "CNY").dateCreate)

                setUsd(usdRate?.amount || 0);
                setCny(cnyRate?.amount || 0);
            } catch (error) {
                console.error("Ошибка при загрузке валют:", error);
                setUsd(0);
                setCny(0);
            } finally {
                setIsLoaded(true);
            }
        };
        fetchCurrencies();
    }, []);

    return (
        <CurrencyContext.Provider value={{ isLoaded, usd, cny, courseDate }}>
            {isLoaded ? (children) : (<Loader></Loader>)}
        </CurrencyContext.Provider>
    );
};

export const useCurrency = () => useContext(CurrencyContext);
